import React, { useMemo } from 'react'
import { gql, useQuery } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import Select from 'packages/ui/FilterSelectMulti'

import useFilters from '../../store'
import {useSites} from 'store'

const OPERATION_COUNT_PORTAL_ADVERTISEMENTS = gql`
  query CountPortalAdvertisements($site_sf_ids: [ID]) {
    counting: countPortalAdvertisements(site_sf_ids: $site_sf_ids) {
      count
      key
    }
  }
`

const Status = () => {
  const [{ selected }] = useSites()
  const { data, loading } = useQuery(OPERATION_COUNT_PORTAL_ADVERTISEMENTS, {
    variables: {
      site_sf_ids: selected.map(({ sf_id }) => sf_id)
    }
  })
  const [filters, setFilters] = useFilters()
  const past = useMemo(() => {
    if (loading) {
      return {}
    }
    return data.counting.find(
      ({ key }) => key === 'past',
    )
  }, [data])

  const current = useMemo(() => {
    if (loading) {
      return {}
    }
    return data.counting.find(
      ({ key }) => key === 'current',
    )
  }, [data])

  const future = useMemo(() => {
    if (loading) {
      return {}
    }
    return data.counting.find(
      ({ key }) => key === 'future',
    )
  }, [data])

  const { t } = useTranslation()
  const choices = [
    {
      label: t('advertisements.statuses.current'),
      value: current.key,
      count: current.count,
      id: 1,
    },
    {
      label: t('advertisements.statuses.future'),
      value: future.key,
      count: future.count,
      id: 2,
    },
    {
      label: t('advertisements.statuses.past'),
      value: past.key,
      count: past.count,
      id: 3,
    },
  ]

  return (
    <Select
      options={choices}
      onChange={statuses => setFilters(prev => ({...prev, statuses }))}
      values={filters.statuses}
      placeholder={t('advertisements.table.status')}
    />
  )
}

export default Status
